/**
 * Microsoft Clarity Project IDs
 *
 * These values should be added to your .env file:
 * NEXT_PUBLIC_CLARITY_ORG_DASHBOARD_NOT_CONNECTED=pqwcntcdz6
 * NEXT_PUBLIC_CLARITY_ORG_DASHBOARD_CONNECTED=pxiwhe8vze
 * NEXT_PUBLIC_CLARITY_DONOR=texano7z1p
 */

export const CLARITY_PROJECT_IDS: Record<string, { key: string; name: string }> = {
  ORG_DASHBOARD_NOT_CONNECTED: {
    key: process.env.NEXT_PUBLIC_CLARITY_ORG_DASHBOARD_NOT_CONNECTED || "",
    name: "ORG_DASHBOARD_NOT_CONNECTED",
  },
  ORG_DASHBOARD_CONNECTED: {
    key: process.env.NEXT_PUBLIC_CLARITY_ORG_DASHBOARD_CONNECTED || "",
    name: "ORG_DASHBOARD_CONNECTED",
  },
  DONOR: { key: process.env.NEXT_PUBLIC_CLARITY_DONOR || "", name: "DONOR" },
} as const;
